export default {
      id: "reefer-cooling-usage",
      viewBox: "0 0 24 32",
      url: __webpack_public_path__ + "img/icons.svg#reefer-cooling",
      toString: function () {
        return this.url;
      }
    }